import { h } from 'preact';
import { useStyles } from '../../../common/hooks';
import { withBreakPoints } from '../../hoc';
import { ExtraInfos, HeaderInfos } from '../info';
import { SECTION_TOP_DEFAULT_STYLE } from './styles';

function SectionTop({ hidden, containerVisible, isTv }) {
  const setStyle = useStyles();
  return (
    <div className="magneto--section-top" style={setStyle(SECTION_TOP_DEFAULT_STYLE)}>
      <HeaderInfos hidden={hidden} containerVisible={containerVisible} />
      {!hidden && !isTv && <ExtraInfos />}
    </div>
  );
}

export default withBreakPoints(SectionTop);
